import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { map, concat, find, cloneDeep, get, orderBy } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {Helmet} from 'react-helmet';

import { usersActions } from '../../../data/actions/users';
import { searchActions } from '../../../data/actions/search';

import Spinner from '../../../components/common/Spinner';
import CSVImportModal from '../../../components/common/CSVImportModal';

// const userFormRef = React.createRef();
class BulkUser extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userID: null,
			user: null,
			products: null,
			restrictedImprints: [],
			silos: [],
			restrictReason: null
		}
		this.bulkAddProducts = this.bulkAddProducts.bind(this);
		this.deleteProduct = this.deleteProduct.bind(this);
		this.assignACL = this.assignACL.bind(this);
		this.cancel = this.cancel.bind(this);
		this.getRestrictedImprints = this.getRestrictedImprints.bind(this);
	}
	
	componentDidMount() {
		const { match, dispatch } = this.props,
			userID = match.params.id;		

		dispatch(usersActions.getUser(userID)).then(user=>{
			this.setState({
				userID,
				user
			});
		});
		dispatch(usersActions.getImprints());
	}
	
	deleteProduct(id){
		let { products } = this.state;
		products = products.filter(product=>product.id !== id);
		this.setState({products});
	}
	
	getRestrictedImprints(foundImprints) {
		let { products, user: { acl } } = this.state;
		let { imprints } = this.props.users;
		let restrictedImprints = [];
		let silos = [];
		let restrictReason;
		
		const addToRestricted = (imprintId, reason) => {
			const imprintData = find(imprints, i=>i.id == imprintId);
			for(let silo of imprintData.silos){
				if(!silos.includes(silo))
					silos.push(silo);
			}
			if(!find(restrictedImprints, i=>i.id == imprintData.id)) {
				restrictedImprints.push(imprintData);
				restrictReason = reason;
			}
				
		}
		
		for(let imprintId of foundImprints) {
			if(acl.imprint_ids.length == 0) {
				addToRestricted(imprintId, 'admin');
				continue;	
			}
			
			for(let entry of acl.product_ids) {
				const entryKeys = Object.keys(entry);
				if(entryKeys && entryKeys[0] == String(imprintId)) {
					if(entry[imprintId][0] == '*') {
						addToRestricted(imprintId, 'user')
					}
					
				}
			}
		}
		return { restrictedImprints, restrictReason, silos };

	}
	
	bulkAddProducts(fields) {
		if(!fields.length)
			return;
			
		const source = 'products';
		const searchString = map(fields, 'upc').join('\n');
		return this.props.dispatch(searchActions.getSearchImport(searchString, [source], false))
		.then(results=>{
			let foundImprints = [];
			results = results.filter(item=>item.exactMatch).map(item=>{
				const product = item.result[0];
				foundImprints.push(product.raw.imprint_id);
				return product;
			});
			
			const { restrictedImprints, restrictReason, silos } = this.getRestrictedImprints(foundImprints);
			this.setState({
				products: results,
				restrictedImprints,
				restrictReason, 
				silos
			})
			return results;
		});
	}
	
	writeRule(obj, key, val) {
		let foundEntry = null;
		for(let entry of obj) {
			const entryKeys = Object.keys(entry);
			if(entryKeys && entryKeys[0] == key) {
				foundEntry = entry;
				break;
			}
		}
		if(foundEntry) {
			if(foundEntry[key][0] == '*')
				foundEntry[key] = [];
			if(!foundEntry[key].includes(val))
				foundEntry[key].push(val);
		}
		else {
			obj.push({
				[key]: [val]
			})
		}
	}
	
	cancel() {
		this.props.history.push('/admin/users/');
	}
	
	assignACL(){
		let { products, user: { acl }, silos } = this.state;
		let { imprints } = this.props.users;
		for(let product of products) {
			const productId = String(product.raw.id);
			const artistId = String(product.raw.artist_id);
			const imprintId = String(product.raw.imprint_id);
			const imprint = find(imprints, i=>i.id == Number(imprintId));
			const labelId = String(imprint.label_id);
			
			this.writeRule(acl.imprint_ids, labelId, imprintId);
			this.writeRule(acl.artist_ids, imprintId, artistId);
			this.writeRule(acl.product_ids, imprintId, productId);
		}
		
		let userSilos = this.state.user.users_silos;
		for(let silo of silos) {
			let userSilo = find(userSilos, us=>us.silo == silo);
			if(userSilo && userSilo.client_admin)
				userSilo.client_admin = false;
		}
		
		return this.setState({
			user: {
				...this.state.user,
				acl,
				users_silos: [...userSilos]
			}
		}, ()=>{
			this.props.dispatch(usersActions.addUser(this.state.user, this.props.users.imprints));
			this.props.history.push('/admin/users/');
		})
	}
	
	render() {
		const { userID, user: currentUser, products, restrictedImprints, restrictReason } = this.state,
			{ imprints, loading } = this.props.users;
			
		if(!currentUser)
			return <Spinner enabled={loading} />;
		
		const { user: owner } = this.props.user;        
		
		let CSVFields = [
			{key: 'upc', required: true, label: 'UPC (barcode)', placeholder: '656605355382'}
		];
		let restrictReasonText;
		switch (restrictReason) {
			case 'admin':
				restrictReasonText = 'This user currently has access to the entire catalog. This user will now be restricted to the listed products for the below imprints only:';
				break;
			case 'user':
				restrictReasonText = 'This user currently has full access to the below imprints. This user will now be restricted to the listed products only:'
				break;
		}

		
		return <div className="users-management">
			<h2 className="users-management-title">Bulk assign products for <Link to={`/admin/users/${currentUser.id}`}>{currentUser.first_name} {currentUser.last_name} ({currentUser.invitee_email})</Link></h2>
			<React.Fragment>
				<CSVImportModal fields={CSVFields} buttonClass="default-btn default-btn--small milestone-import-btn default-btn--light" modalTitle="Import Products" buttonTitle="Choose File" onSubmit={this.bulkAddProducts} />
			</React.Fragment>
			{products && <React.Fragment> 
				<div className={`page-filter products`}>	
					Matching Products:
					<div className="tag-list">
						<div className="page-filter-item">
							<div className="page-filter-list">
								{orderBy(products, 'name').map(product=><div key={product.id} className="tag">
									<div className="tag-name-holder">
										<div className="tag-name">
											<span>{product.name}</span>
										</div>
										<a
											className="close-link"
											onClick={()=>this.deleteProduct(product.id)}
										>
											&times;
										</a>
									</div>
								</div>)}
							</div>
						</div>
					</div>
				</div>
				{restrictedImprints.length > 0 && <div className={`page-filter imprints`}>	
					{restrictReasonText}
					<div className="tag-list">
						
						<div className="page-filter-item">
							<div className="page-filter-list">
								{orderBy(restrictedImprints, 'name').map(product=><div key={product.id} className="tag">
									<div className="tag-name-holder">
										<div className="tag-name">
											<span>{product.name}</span>
										</div>
									</div>
								</div>)}
							</div>
						</div>
					</div>
				</div>}
				<div>
					<button className="default-btn default-btn--small default-btn--light" onClick={this.cancel}>Cancel</button>
					&nbsp;&nbsp;
					<button className="default-btn default-btn--small" onClick={this.assignACL}>Save Products</button>
				</div>
			</React.Fragment>}
			<Helmet>
				<title>Products - User Management - Admin</title>
			</Helmet>
		</div>
	}
}


function mapStateToProps(state) {
	return {
		users: state.users,
		user: state.user,
		filter: state.filter,
	} 
}

export default connect(mapStateToProps)(withRouter(BulkUser));
